import './Button.css'

export default function button ({
    children,
    onClick,
    isActive,
    // color = '#6ce609', 
    color = '#e5da71',
}) {
   
    return(
        <button 
        className={isActive ? 'button clicked' : 'button'}
        style={{ '--button-color': color }}
        onClick={onClick}
        >
        {children}
        </button>
    )
}